// import React, { useContext, useEffect } from "react";
// import { GlobalStateContext } from "../../context/GlobalStateContext";
// import styles from "./CompaniesListStyle.module.css";
// import "./CompanyListStyle.css";

// function CompaniesList() {
//   const { filteredCompanies } = useContext(GlobalStateContext);
//   useEffect(() => {
//     if (!filteredCompanies?.length) return; // Prevent execution if no companies are available
//     // Dynamically execute scripts for each widget after rendering
//     filteredCompanies.forEach((company) => {
//       const container = document.getElementById(
//         `widget-container-${company.companyID}`
//       );

//       // Ensure container exists and is empty before appending
//       if (container && !container.hasChildNodes()) {
//         const script = document.createElement("script");
//         script.src =
//           "https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js";
//         script.async = true;

//         // Parse widget configuration from the company data
//         const widgetConfig = JSON.stringify({
//           // symbol: company.widget?.match(/"symbol": "(.*?)"/)?.[1] || "",
//           symbol: company.symbol,
//           width: 350,
//           isTransparent: false,
//           colorTheme: "light",
//           locale: "en",
//         });
//         script.innerHTML = widgetConfig;

//         container.appendChild(script);
//       }
//     });

//     // Cleanup function to clear widgets when component unmounts
//     return () => {
//       filteredCompanies.forEach((company) => {
//         const container = document.getElementById(
//           `widget-container-${company.companyID}`
//         );
//         if (container) {
//           container.innerHTML = ""; // Clear container content
//         }
//       });
//     };
//   }, [filteredCompanies]);
//   useEffect(() => {
//     const applyStyles = () => {
//       if (window.innerWidth < 1024) {
//         const widgets = document.querySelectorAll(
//           ".tradingview-widget-container"
//         );
//         widgets.forEach((widget) => {
//           widget.style.height = "90 px";
//         });
//       } else {
//         // Reset styles for larger screens if needed
//         const widgets = document.querySelectorAll(
//           ".tradingview-widget-container"
//         );
//         widgets.forEach((widget) => {
//           widget.style.height = "126 px";
//         });
//       }
//     };

//     // Initial check and apply styles
//     setTimeout(applyStyles, 500);

//     // Cleanup on unmount
//     return () => {
//       window.removeEventListener("resize", applyStyles);
//     };
//   }, [window.innerWidth]);

//   return (
//     <section className={styles.sectionThree}>
//       <ul className={styles.companyList} id="companyList">
//         {filteredCompanies.map((company, index) => (
//           <li className={styles.companyItem} key={company.companyID}>
//             <h3>
//               {index + 1}. <br className={styles.idCompanyBr} />
//               <a
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 href={company.IRwebsiteLink}
//               >
//                 {company.companyName}
//               </a>
//             </h3>
//             {/* Widget container */}
//             <div
//               id={`widget-container-${company.companyID}`}
//               className="tradingview-widget-container"
//             ></div>
//             <a
//               className={styles.annualReportLink}
//               href={company.annualReportLink}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Annual Report 2023
//             </a>
//           </li>
//         ))}
//       </ul>
//     </section>
//   );
// }

// export default CompaniesList;
import React, { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "../../context/GlobalStateContext";
import styles from "./CompaniesListStyle.module.css";
import "./CompanyListStyle.css";

function CompaniesList() {
  const { filteredCompanies } = useContext(GlobalStateContext);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

  // Slice the data for the current page
  const currentCompanies = filteredCompanies.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  // Reset pagination when filteredCompanies change
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredCompanies]);
  useEffect(() => {
    if (!currentCompanies.length) return;

    currentCompanies.forEach((company) => {
      const container = document.getElementById(
        `widget-container-${company.companyID}`
      );

      if (container && !container.hasChildNodes()) {
        const script = document.createElement("script");
        script.src =
          "https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js";
        script.async = true;

        const widgetConfig = JSON.stringify({
          symbol: company.symbol,
          width: 350,
          isTransparent: false,
          colorTheme: "light",
          locale: "en",
        });
        script.innerHTML = widgetConfig;

        container.appendChild(script);
      }
    });

    return () => {
      currentCompanies.forEach((company) => {
        const container = document.getElementById(
          `widget-container-${company.companyID}`
        );
        if (container) {
          container.innerHTML = "";
        }
      });
    };
  }, [currentCompanies]);

  return (
    <section className={styles.sectionThree}>
      <ul className={styles.companyList} id="companyList">
        {currentCompanies.map((company, index) => (
          <li className={styles.companyItem} key={company.companyID}>
            <h3>
              {index + 1 + (currentPage - 1) * itemsPerPage}.{" "}
              <br className={styles.idCompanyBr} />
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={company.IRwebsiteLink}
              >
                {company.companyName}
              </a>
            </h3>
            <div
              id={`widget-container-${company.companyID}`}
              className="tradingview-widget-container"
            ></div>
            <a
              className={styles.annualReportLink}
              href={company.annualReportLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Annual Report 2024
            </a>
          </li>
        ))}
      </ul>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
}

export default CompaniesList;
